export default import.meta.ROLLDOWN_FILE_URL_PJDFhFdlzz6i7QMvLW3v2g